import { storeToRefs } from "pinia";
import { useMCampaignStore } from "@stores/mCampaign";
import { useMCreativesStore } from "@stores/mCreatives";
import { useMMediumUploadsStore } from "@stores/mMediumUploads";
import { useMTemplatesStore } from "@stores/mTemplates";
import { creativeHeadline, creativeThumbnail, creativeVisuals } from "@composables/creativeSummary";
import type { MCampaignPlacement, MCreative } from "@/types";

export const useCreativeSummary = () => {
  const { localeOptions } = storeToRefs(useMCampaignStore());
  const { mMediumUploads } = storeToRefs(useMMediumUploadsStore());
  const { mTemplates } = storeToRefs(useMTemplatesStore());
  const { adSetVariables } = storeToRefs(useMCreativesStore());

  const thumbnail = (creative: MCreative) => creativeThumbnail(creative, mMediumUploads.value);

  const headline = (creative: MCreative) => creativeHeadline(creative, mTemplates.value);

  const visuals = (creative: MCreative, placement: MCampaignPlacement) =>
    creativeVisuals(creative, placement, mMediumUploads.value, mTemplates.value, adSetVariables.value);

  const localeLabel = (creative: MCreative) =>
    localeOptions.value.find(
      (option: { value: string; label: string }) => option.value === creative.redirection_attributes?.locale_id,
    )?.label ?? null;

  return { thumbnail, headline, visuals, localeLabel };
};
